import { render } from "./AgendaPage.vue?vue&type=template&id=53140cce&scoped=true"
import script from "./AgendaPage.vue?vue&type=script&lang=js"
export * from "./AgendaPage.vue?vue&type=script&lang=js"

import "./AgendaPage.vue?vue&type=style&index=0&id=53140cce&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53140cce"]])

export default __exports__